import { getWindowLocationValues } from './helpers'

/**
 * Track when a user enters the post-conversion qualification flow.
 *
 * @param {object} statsigClient
 * @param {object} event
 * @param {number} event.matchCount - Number of matched companies.
 * @param {object} event.scope
 */
export function trackPostConversionEnteredEvent(
  statsigClient,
  { matchCount, scope },
) {
  statsigClient?.logEvent('entered_post_conversion', null, {
    match_count: matchCount,
    ...getWindowLocationValues(scope),
  })
}

/**
 * Track when a user completes the post-conversion qualification flow.
 *
 * @param {object} statsigClient
 * @param {object} event
 * @param {number} event.matchCount - Number of matched companies.
 * @param {object} event.scope
 */
export function trackPostConversionCompletedEvent(
  statsigClient,
  { matchCount, scope },
) {
  statsigClient?.logEvent('completed_post_conversion', null, {
    match_count: matchCount,
    ...getWindowLocationValues(scope),
  })
}

/**
 * Track when a user submits an answer to a post-conversion qualification question.
 * Logs the question as the event value to identify which question was answered.
 *
 * @param {object} statsigClient
 * @param {object} event
 * @param {string} event.question - The question identifier, used as event value.
 * @param {string} event.answer - The selected answer.
 * @param {object} event.scope
 */
export function trackPostConversionQuestionSubmittedEvent(
  statsigClient,
  { question, answer, scope },
) {
  statsigClient?.logEvent('submitted_post_conversion_question', question, {
    answer,
    ...getWindowLocationValues(scope),
  })
}
